import { render, staticRenderFns } from "./configReposicionOne.vue?vue&type=template&id=570f229a&scoped=true"
import script from "./configReposicionOne.vue?vue&type=script&lang=js"
export * from "./configReposicionOne.vue?vue&type=script&lang=js"
import style0 from "./configReposicionOne.vue?vue&type=style&index=0&id=570f229a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f229a",
  null
  
)

export default component.exports